import React, { useContext, useEffect } from 'react';

import ExplainerPanel from '../../common/components/ExplainerPanel/ExplainerPanel';
import { Provider } from '../../config';
import { FlowConfigContext } from '../../providers/FlowConfigContext';
import {
  ExplainerPanelDescriptionAlignment,
  ExplainerPanelSubDescription,
  ExplainerPanelSubDescriptionIcon,
} from '../../common/components/ExplainerPanel/ExplainerPanelProps';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import { Screens } from '../../services/analytics/screens';
import useTermsLinks from '../../common/hooks/useTermsLinks';

function CaptchaExplainerScreen(): JSX.Element {
  const { termsLink, privacyPolicyLink, setAcceptedAllTerms, hasAcceptedAllTerms } = useTermsLinks();
  const {
    provider,
    selectProvider,
    navigateToNextFlow,
  } = useContext(FlowConfigContext);

  useEffect(() => {
    if (!provider || !hasAcceptedAllTerms()) {
      return;
    }

    navigateToNextFlow();
  }, [provider, hasAcceptedAllTerms]);

  const handleStartVerificationClick = async () => {
    setAcceptedAllTerms();
    selectProvider(Provider.CAPTCHA);
  };

  const handleUseCivicAppClick = async () => {
    setAcceptedAllTerms();
    selectProvider(Provider.SIP);
  };

  const subDescriptions: ExplainerPanelSubDescription[] = [
    {
      title: 'common.explainer.subDescription',
      icon: ExplainerPanelSubDescriptionIcon.PERSON,
      alignment: ExplainerPanelDescriptionAlignment.LEFT,
    },
  ];

  return (
    <ExplainerPanel
      title="common.explainer.title"
      showSubDescription={false}
      subDescriptionsWithIcon={subDescriptions}
      onPrimaryButtonPressed={handleStartVerificationClick}
      onSecondaryButtonPressed={handleUseCivicAppClick}
      termsLink={termsLink}
      privacyPolicyLink={privacyPolicyLink}
      dataTestId="IDENTITY_VERIFICATION_HEADER"
    />
  );
}
export default withRouteAnalytics(CaptchaExplainerScreen, Screens.EXPLAINER_CAPTCHA);
